import React from 'react';
import { Button, Div, Group, Header, Panel, Text, Title } from '@vkontakte/vkui';
import { Icon28AddCircleOutline, Icon28DeleteOutline } from '@vkontakte/icons';
import { AppShell, ScreenHeader } from '../../components/Layout/AppShell';
import { LoadingRing } from '../../components/States/States';
import { WORD_PANEL } from '../../routing/routing';
import { wordImagePath } from '../../utils/assets';
import { fitTextSize } from '../../utils/text';

export function WordPanel({ nav = WORD_PANEL, word, wordInDictionary, checkingWordStatus, onBack, toggleDictionary }) {
  return (
    <Panel nav={nav}>
      <ScreenHeader title="Слово" onBack={onBack} />
      <AppShell>
        {word ? (
          <>
            <Group>
              <Div className="flex min-h-[300px] flex-col items-center justify-center text-center">
                {word.image ? (
                  <img src={wordImagePath(word.image)} alt="" className="mb-4 block h-[112px] w-[112px] object-contain" />
                ) : null}
                <Title level="1" className="break-words" style={{ fontSize: `${fitTextSize(word.word, 10, 30, 20)}px` }}>{word.word}</Title>
                <Text className="mt-1 text-[var(--vkui--color_text_secondary)]" style={{ fontSize: `${fitTextSize(`[${word.transcription}]`, 23, 14, 11)}px` }}>[{word.transcription}]</Text>
                <Text className="mt-3 break-words" style={{ fontSize: `${fitTextSize(word.translation, 20, 17, 13)}px` }}>{word.translation}</Text>
              </Div>
            </Group>

            {word.examples ? (
              <Group header={<Header mode="primary" size="large">Примеры использования</Header>}>
                <Div>
                  <div
                    className="[&_p:last-child]:mb-0 [&_p]:mb-[14px] [&_.example-origin]:font-semibold [&_.example-translation]:text-[var(--vkui--color_text_secondary)]"
                    dangerouslySetInnerHTML={{ __html: word.examples }}
                  />
                </Div>
              </Group>
            ) : null}

            <Group>
              <Div>
                {checkingWordStatus ? (
                  <LoadingRing />
                ) : (
                  <Button
                    size="l"
                    stretched
                    mode={wordInDictionary ? 'secondary' : 'primary'}
                    before={wordInDictionary ? <Icon28DeleteOutline /> : <Icon28AddCircleOutline />}
                    onClick={toggleDictionary}
                  >
                    {wordInDictionary ? 'Удалить из словаря' : 'Добавить в словарь'}
                  </Button>
                )}
              </Div>
            </Group>
          </>
        ) : null}
      </AppShell>
    </Panel>
  );
}
